<app-overlay-loader *ngIf="loader"></app-overlay-loader>
<div class="content-container">
  <!-- Welcome Section -->
  <div *ngIf="activeSection === 'welcome'" class="content-section">
    <div [innerHTML]="welcomeContent"></div>
  </div>
  
  <!-- General Info Section -->
  <div *ngIf="activeSection === 'general-info'" class="content-section">
    <div [innerHTML]="generalInfo"></div>
  </div>
  
  <!-- General Approach Section -->
  <div *ngIf="activeSection === 'general-approach'" class="content-section">
    <div [innerHTML]="generalApproach"></div>
  </div>
  
  <!-- List of Cases Section -->
  <div *ngIf="activeSection === 'list-of-cases'" class="content-section">
    <h2>List of Cases</h2>
    
    <!-- Cases Table (shown when no case is selected) -->
    <div class="case-by-layout" *ngIf="!selectedCase">
      <table style="border: 1px solid #ccc;">
        <thead>
          <tr >
            <th style="text-align: start;width: 50%;padding:1rem; ">Case by Number</th>
            <th style="text-align: start;width: 50%;padding:1rem;" colspan="2">Case by Diagnosis</th>
          </tr>
        </thead>
        <tbody>
          <tr >
            <td valign="top" style="border: 1px solid #ccc;" >
              <div *ngFor="let caseItem of allCases; let i = index" style="margin-bottom: 10px; padding:1rem">
                <a class="link_names" >
                  Case {{ i + 1 }}: 
                </a>
                <a class="link_names" (click)="selectCase(caseItem)" style="cursor: pointer;">
                  {{ caseItem.case_title }}
                </a>
              </div>
            </td>
            <td valign="top" style="border: 1px solid #ccc;" >
              <div *ngFor="let diagnosis of diagnosisList" style="margin-bottom: 12px;width: 100%;border-bottom: 1px solid #ccc ">
               <td style="width: 5rem;padding:1rem;">{{ diagnosis.diagnosis_title }}</td>
                <td >
                <span *ngFor="let caseItem of diagnosis.cases; let i = index" style="display: block; padding:1rem">
                  <a class="link_names" (click)="selectCase(caseItem)" style="cursor: pointer;">
                    {{ caseItem.case_title }}
                  </a>
                </span>
              </td>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Case Content Display Section (shown when a case is selected) -->
    <div *ngIf="selectedCase" class="case-content-section">
      <button class="back-button" (click)="selectedCase = null">Back to List</button>
      <h3>{{ selectedCase.case_title }}</h3>
      <div *ngIf="selectedCase['case_content']" [innerHTML]="selectedCase['case_content']"></div>
      <div *ngIf="!selectedCase['case_content']" class="loading-message">
        Loading case content...
      </div>
    </div>
  </div>
  
  <!-- Practice Cases -->
  <div *ngIf="activeSection.startsWith('case-')" class="content-section">
    <h2>Practice Case: {{ currentCase?.case_title }}</h2> 
    <div *ngIf="currentCase" class="case-content-section">
      <button class="back-button" (click)="goBackToCasesList()">Back to Practice Cases</button>
      <div *ngIf="currentCase.case_content" [innerHTML]="currentCase.case_content"></div>
      <div *ngIf="!currentCase.case_content" class="loading-message">
        Loading case content...
      </div>
    </div>
    
    <div *ngIf="!currentCase" class="loading-message">
      Please select a case from the Practice Cases menu.
    </div>
  </div>
  
  <!-- Interactive Cases -->
  <div *ngIf="activeSection === 'interactive-cases'" class="content-section">
    <app-interactive-cases (navigate)="onCaseNavigate($event)"></app-interactive-cases>
  </div>
  
  <!-- Case Explanation -->
  <div *ngIf="activeSection === 'case-explanation'" class="content-section">
    <!-- <div *ngIf="!explanationCaseId" class="loading-message">
      Please select a case from the Interactive Cases to view its explanation.
    </div> -->
    <div *ngIf="explanationCaseId">
      <button class="back-button" (click)="goBackToInteractiveCases()">Back to Interactive Cases</button>
      <app-case-explanation [caseId]="explanationCaseId"></app-case-explanation>
    </div>
  </div>
</div>
